"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCreditAgreementMetricsParams = void 0;
const createCreditAgreementMetricsParams = () => {
    // currently no params required. can extend as needed.
    return {
        isValid: true,
        params: null,
    };
};
exports.createCreditAgreementMetricsParams = createCreditAgreementMetricsParams;
//# sourceMappingURL=creditAgreementMetricsParams.js.map